import {SnackMessage} from './snack-message.model';
import {Subject} from 'rxjs/Subject';

export class SnackMessageService {

  private messages: SnackMessage[] = [];
  public newMessage: Subject<SnackMessage> = new Subject<SnackMessage>();

  constructor() {
    this.newMessage.subscribe(
      (snackMessage: SnackMessage) => {
        this.messages.push(snackMessage);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/snack-messages/snack-message.service.ts